import React, { useRef, useEffect } from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";

export const ModernDropdownContent = ({
  selectList,
  handleChange,
  setDropdownTitle,
  isChangeTitle,
  showDropDown,
  setShowDropDown,
}) => {
  const { getTextByKey } = useContent();

  /* change selection of dropdown + handleChange if needed */
  const changeDropdownSelection = (e, itemKey) => {
    if (handleChange) {
      handleChange(e, itemKey);
    }
    if (isChangeTitle) {
      setDropdownTitle(selectList[itemKey]);
    }
  };

  const handleClickOnTab = (e, itemKey) => {
    if (selectList.length - 1 === Number(itemKey) && e.key === "Tab") {
      setShowDropDown(false);
    }
  };

  const escFunction = (e) => {
    if (e.key === "Escape") {
      setShowDropDown(false);
    }
  };
  const myRef = useRef(null);

  const executeScroll = () => myRef.current.scrollIntoView();
  useEffect(() => {
    if (showDropDown) {
      executeScroll();
    }
  }, [showDropDown]);

  if (selectList) {
    return (
      <div
        ref={myRef}
        className="dropdown-content"
        id="scroll-div-dropdown"
        onKeyDown={(e) => escFunction(e)}
      >
        {Object.keys(selectList).map((itemKey) => (
          <span
            tabIndex={showDropDown ? 0 : -1}
            className={
              window.location.pathname.substring(3, 5) === itemKey
                ? "active"
                : ""
            }
            key={itemKey.text || itemKey}
            value={itemKey.text || itemKey}
            onKeyDown={(e) => handleClickOnTab(e, itemKey)}
            onClick={(e) => changeDropdownSelection(e, itemKey.text || itemKey)}
          >
            {getTextByKey(selectList[itemKey].text) ||
              selectList[itemKey].text ||
              selectList[itemKey]}
          </span>
        ))}
      </div>
    );
  } else {
    return null;
  }
};
